/* global I18n */

import class_names from "classnames"
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent
} from "./tooltip"
import React from "react"

function PerspectiveIcon({perspective, tooltip_placement}) {
  return (
    <Tooltip className="perspective">
      <TooltipTrigger className={class_names("perspective-image", perspective)}>
      </TooltipTrigger>
      <TooltipContent placement={tooltip_placement}>
        {I18n.t(`js.perspectives.${perspective}`)}
      </TooltipContent>
    </Tooltip>
  )
}

export default PerspectiveIcon
